 
import translation from "./en/common.json";
import translationDraft from "./en/draft.json";

const dictionary = {
  ...translation,
} as const;

const dictionaryDraft = {
  ...translationDraft,
} as const;

export { dictionary, dictionaryDraft };

//export { default as dictionary } from "./en/common.json";
